import React from 'react';
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import logo from '../assets/images/93d3e31639a4d07613de9dccdc8bd5e8.png';

import './Navigation.css';

export default function HeaderBar() {
    return(
        <Navbar  bg="dark"  variant="dark" className="my-navbar">
            <Navbar.Brand href="/"><img alt="ICON" width="50px" height="50px" src={logo} /></Navbar.Brand>
            <Nav className="mr-auto d-flex justify-content-around">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/projects">Projects</Nav.Link>
                <Nav.Link href="/blog">Blog</Nav.Link>
                <Nav.Link href="/resume">Resume</Nav.Link>
                <Nav.Link href="/services">Services</Nav.Link>
            </Nav>

        </Navbar>
    );

}